import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'eyrus-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.sass']
})
export class EyrusStepperComponent implements OnInit {

  @Input() numberOfSteps: Number = 3;
  @Input() steps: Array<any> = [];
  @Output() clickEvent: EventEmitter<any> = new EventEmitter<any>();

  currentStep = this.getCurrentstep() || 0;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    if (changes.steps)
      this.currentStep = this.getCurrentstep();
  }

  /**
   * Trigger action for each step
   * @param index step index
   */
  stepAction(index: number) {
    this.completeStep(index);
  }

  /**
   * Let parents know about the event
   */
  onClick(index) {
    this.clickEvent.emit(index);
  }

  /**
   * Complete an step from given index
   * @param index step index
   */
  completeStep(index) {
    const currentStep = this.steps[index];
    const nextStep = this.steps[index + 1] ? this.steps[index + 1] : null;
    const prevStep = this.steps[index - 1] ? this.steps[index - 1] : null;

    if (currentStep) {
      currentStep.completed = true;
      currentStep.active = false;
    }

    if (nextStep)
      nextStep.active = true;

    if (prevStep)
      prevStep.active = false;

    this.currentStep = index + 1;
  }

  /**
   * Get current step index
   */
  getCurrentstep() {
    const index = this.steps.findIndex(e => e.active);
    return index === -1 ? 0 : index;
  }

}
